import _JSXStyle from "styled-jsx/style";
import Fecha from 'fecha'; // TODO replace with date-fns/parse after v2 is released

import noop from 'lodash.noop';
import React from 'react';
import Col from "../Layout/Col";
import Row from "../Layout/Row";
import Nav from "../Nav/Nav";
import NavLabel from "./components/NavLabel";
import { getMonths, getYears } from "./util/dateRanges";
var format = Fecha.format;
var defaultProps = {
  centerYearSelection: false,
  date: new Date(),
  dateVisible: function dateVisible() {
    return true;
  },
  monthFormat: 'MMM',
  yearFormat: 'YYYY',
  onSelect: noop
};

var MonthCalendar = function MonthCalendar(_ref) {
  var _ref$date = _ref.date,
      date = _ref$date === void 0 ? defaultProps.date : _ref$date,
      _ref$dateVisible = _ref.dateVisible,
      dateVisible = _ref$dateVisible === void 0 ? defaultProps.dateVisible : _ref$dateVisible,
      _ref$centerYearSelect = _ref.centerYearSelection,
      centerYearSelection = _ref$centerYearSelect === void 0 ? defaultProps.centerYearSelection : _ref$centerYearSelect,
      _ref$monthFormat = _ref.monthFormat,
      monthFormat = _ref$monthFormat === void 0 ? defaultProps.monthFormat : _ref$monthFormat,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? defaultProps.onSelect : _ref$onSelect,
      _ref$yearFormat = _ref.yearFormat,
      yearFormat = _ref$yearFormat === void 0 ? defaultProps.yearFormat : _ref$yearFormat;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "jsx-2143917605" + " " + "rg-MonthCalendar"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "gx-0"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Nav, {
    pills: true,
    className: "d-block p-1 m-0",
    style: {
      columnCount: 2,
      columnGap: 0
    }
  }, getMonths(date).map(function (monthYear) {
    return /*#__PURE__*/React.createElement(NavLabel, {
      selected: date.getMonth() === monthYear.getMonth(),
      label: format(monthYear, monthFormat),
      key: monthYear.toString(),
      onClick: function onClick() {
        return dateVisible(monthYear) && onSelect(monthYear);
      },
      visible: dateVisible(monthYear)
    });
  }))), /*#__PURE__*/React.createElement(Col, {
    className: "border-start"
  }, /*#__PURE__*/React.createElement(Nav, {
    pills: true,
    className: "d-block p-1 m-0",
    style: {
      columnCount: 2,
      columnGap: 0
    }
  }, getYears(date, centerYearSelection).map(function (monthYear) {
    return /*#__PURE__*/React.createElement(NavLabel, {
      selected: date.getFullYear() === monthYear.getFullYear(),
      label: format(monthYear, yearFormat),
      key: monthYear.toString(),
      onClick: function onClick() {
        return dateVisible(monthYear) && onSelect(monthYear);
      },
      visible: dateVisible(monthYear)
    });
  }))))), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "2143917605"
  }, ".rg-MonthCalendar.jsx-2143917605{min-width:16em;}"));
};

export default MonthCalendar;